module.exports = __webpack_public_path__ + "static/media/Student Leaderboard 1.653f26a5.png";